import { Adunit } from '@/components/Adunit/Adunit';
import ErrorBoundary from '@/components/ErrorBoundary';
import { ClassNameProvider } from '@/styles/Adunit';
import type { LabradorComponent, StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import withDebugMetadata from 'lib/utils/withDebugMetadata';
import { standaloneComponent } from 'modules/dynamic-components';

export interface StandaloneAdunitProps extends StandaloneComponentProps<typeof Adunit> {
  title: React.ReactNode;
  data: {
    elID?: string;
    placement?: string;
  };
}

export const StandaloneAdunit: StandaloneComponent<StandaloneAdunitProps> = ({ title, data, options, ...props }) => {
  const { $placement, $wrapper, ...$base } = options ?? {};

  const { elID, placement } = data ?? {};

  return (
    <ErrorBoundary>
      <ClassNameProvider value={$base}>
        <Adunit {...$base} {...props}>
          {title}
          <Adunit.Wrapper {...$wrapper}>
            <Adunit.Placement id={elID} ad-placement={placement} {...$placement} />
          </Adunit.Wrapper>
        </Adunit>
      </ClassNameProvider>
    </ErrorBoundary>
  );
};

export const standalone = StandaloneAdunit;

const DynamicStandaloneAdunit = standaloneComponent('ContentAdunit') as typeof StandaloneAdunit;

const LabradorAdunit: LabradorComponent = ({ type, data, meta, descendants }) => {
  return <DynamicStandaloneAdunit data={data} title={'Annons'} {...withDebugMetadata({ type, meta })} />;
};

export default LabradorAdunit;
